import { IonText } from '@ionic/react';
import { ReactElement } from 'react';

const WhyBeacon = (): ReactElement => {
  return (
    <IonText>
      <p>
        Unleash the <strong>power</strong> of your cobots with Beacon, a{' '}
        <strong>free</strong> software solution that provides a robust toolset
        to help you understand how your application is running and gain
        visibility into issues to proactively support production.
      </p>
    </IonText>
  );
};

export { WhyBeacon };
